import HeroImage from "@/assets/images/landing-hero.webp";
import MedirectLogoImage from "@/assets/logo/medirect-primary-dark.webp";
import { Avatar, AvatarGroup } from "@/components/ui/avatar";
import { cn } from "@/utils/ui";

import { SignInFlow } from "./SignInFlow";

// Sample expert data for the avatar group
const experts = [
  {
    name: "Dr. Sarah Mitchell",
    avatar: "https://i.pravatar.cc/150?u=sarah.mitchell@medirect.com",
  },
  {
    name: "Dr. James Wilson",
    avatar: "https://i.pravatar.cc/150?u=james.wilson@medirect.com",
  },
  {
    name: "Dr. Emily Davis",
    avatar: "https://i.pravatar.cc/150?u=emily.davis@medirect.com",
  },
];

export const HeroSection = () => {
  return (
    <main className="relative h-screen w-screen overflow-hidden bg-background-dark text-foreground-light">
      {/* Hero image as background */}
      <div className="absolute inset-0">
        <picture
          className={cn(
            "absolute right-0 top-0 h-[105vh] w-full opacity-20 lg:opacity-100"
          )}
        >
          <img
            src={HeroImage}
            alt=""
            className="h-full w-full object-contain object-right-top"
          />
        </picture>
      </div>

      {/* Content container centered in the page */}
      <div className="container relative z-10 mx-auto flex h-full items-center">
        <div className="grid h-full max-w-4xl grid-rows-[auto_1fr_auto] gap-4 px-6 py-20">
          <figure className="h-32">
            <img src={MedirectLogoImage} alt="" className="h-full object-contain" />
          </figure>

          <div className="my-auto space-y-8">
            <h1
              className={cn(
                "text-wrap font-montserrat text-6xl font-bold capitalize",
                "md:text-balance"
              )}
            >
              Your Medicolegal Reporting Assistant
            </h1>

            <p
              className={cn(
                "max-w-full text-wrap text-xl text-dark-100",
                "md:text-balance"
              )}
            >
              AI-powered software to help you organise, search, and summarise
              documents; take faster notes; dictate live; and review, edit, and
              finalise reports in record time while staying fully in control of every
              word and opinion.
            </p>

            <Note content="MEDirect takes the privacy of healthcare records seriously. Data is hosted in Australia, encrypted in transit & at rest, and managed within an ISO 27001 / SOC 2 / HIPAA–aligned environment. Sensitive case files never leave our secure platform." />

            <SignInFlow />
          </div>

          <div className="flex items-center gap-4">
            <div className="flex flex-col gap-2">
              <AvatarGroup
                avatars={experts.map((expert, index) => (
                  <Avatar
                    key={index}
                    src={expert.avatar}
                    alt={expert.name}
                    size="sm"
                    className="border-2 border-background"
                  />
                ))}
                maxVisible={3}
                size="sm"
                overlap="-0.75rem"
              />
            </div>

            <p className="text-sm text-foreground-light-muted">
              Trusted by 350+ medical experts
            </p>
          </div>
        </div>
      </div>
    </main>
  );
};

type NoteProps = {
  content: string;
};
const Note = ({ content }: NoteProps) => {
  return (
    <div className="inline-flex max-w-prose text-balance rounded-xl bg-accent-50 p-4 italic leading-7 text-accent-900">
      {content}
    </div>
  );
};

